import React from 'react';
import { motion } from 'framer-motion';
import { RiCloseLine, RiDownloadLine } from 'react-icons/ri';
import './PrescriptionModal.css';

const PrescriptionModal = ({ prescription, onClose, onUpdateStatus }) => {
    const downloadImage = () => {
        window.open(prescription.prescriptionImage, '_blank');
    };

    return (
        <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <motion.div
                className="modal-content"
                initial={{ scale: 0.5, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.5, opacity: 0 }}
            >
                <button className="close-btn" onClick={onClose}>
                    <RiCloseLine />
                </button>

                <div className="modal-header">
                    <h2>Prescription Details</h2>
                </div>

                <div className="modal-body">
                    <div className="info-section">
                        <div className="info-group">
                            <label>Patient Name</label>
                            <p>{prescription.name || 'No Name'}</p>
                        </div>
                        <div className="info-group">
                            <label>Phone Number</label>
                            <p>{prescription.phone || 'No Phone'}</p>
                        </div>
                        <div className="info-group">
                            <label>Status</label>
                            <select
                                value={prescription.status || 'pending'}
                                onChange={(e) => onUpdateStatus(prescription._id, e.target.value)}
                                className="status-select"
                            >
                                <option value="pending">Pending</option>
                                <option value="processed">Processed</option>
                                <option value="completed">Completed</option>
                            </select>
                        </div>
                        <div className="info-group">
                            <label>Submission Date</label>
                            <p>{prescription.createdAt ? new Date(prescription.createdAt).toLocaleString() : 'No Date'}</p>
                        </div>
                    </div>

                    <div className="prescription-image-section">
                        <label>Prescription Image</label>
                        <div className="image-container">
                            <img
                                src={prescription.prescriptionImage || 'default-image-url'}
                                alt="Prescription"
                                onError={(e) => {
                                    e.target.src = 'default-image-url';
                                    e.target.onerror = null;
                                }}
                            />
                            {prescription.prescriptionImage && (
                                <button className="download-btn" onClick={downloadImage}>
                                    <RiDownloadLine /> Download
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </motion.div>
        </motion.div>
    );
};

export default PrescriptionModal; 